import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { FullScreenModeController } from '../components/FullScreenModeController/FullScreenModeController'
import Header from '../components/Header'

export const MainLayout: FC = () => {
  return (
    <>
      <FullScreenModeController />
      <Header />
      <Outlet />
    </>
  )
}
